export default __webpack_public_path__ + "media/src/assets/images/LinehaulDelivery-34744b14295341d5cfad9a650dfc8f99.svg";